export interface ITimer {
	id: number
	name: string
	type: number
	periods: ITimerPeriodCreate[]
}

export interface ITimerCreate {
	name: string	
	type: number
	periods: ITimerPeriodCreate[]
}

export interface ITimerUpdate extends ITimerCreate{
	id: number
}

export interface ITimerPeriodCreate {
	guid?: string
	start: number
  	end: number
  	value: number
}

export enum TimerType {
  BulkOrderCustomer = 1,
  BulkOrderAdmin = 2
}

export const timerTypes = [
  {
	name: "Таймер для клиента в запросы предложения",
	type: TimerType.BulkOrderCustomer
  },
  {
	name: "Таймер для менеджера в запросы предложения",
	type: TimerType.BulkOrderAdmin
  }
]

export const TIMER_KEY = "TIMER_KEY"
